<div class="wrapper">
    <p class="font-weight-bold" id="title">
        Brillanten
    </p>
    <div class="card">
        <div class="card-body">

            <app-table-header
                    [(pageIndex)]="brillantService.pageIndex"
                    [pageCount]="brillantService.data?.pageCount"
                    [error]="brillantService.error"
                    [loading]="brillantService.loading"
                    [disableFilter]="true"
                    (reload)="brillantService.loadBrillants()"
            >
            </app-table-header>

            <ng-container *ngIf="brillantService.data != null">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>
                            <p>Steingröße</p>
                        </th>
                        <th>
                            <p>
                                TW/SI
                            </p>
                        </th>
                        <th>
                            <p>
                                W/SI
                            </p>
                        </th>
                        <th>
                            <p>
                                TW/IF (Lupenrein)
                            </p>
                        </th>
                        <th>
                            <p>
                                Princess
                            </p>
                        </th>
                        <th>
                            <p>
                                SI Schwarz
                            </p>
                        </th>
                        <th>
                            <p>
                                SI Blau
                            </p>
                        </th>
                        <th>
                            <p>
                                SI Grün
                            </p>
                        </th>
                        <th>
                            <p>
                                SI Braun
                            </p>
                        </th>
                        <th>
                            <p>
                                SI Gelb
                            </p>
                        </th>
                        <th>
                            <p>
                                Rubin
                            </p>
                        </th>
                        <th>
                            <p>
                                Saphir
                            </p>
                        </th>
                        <th>
                            <p>
                                Smaragd
                            </p>
                        </th>
                        <th>
                            <p>
                                Zirkonia
                            </p>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let brillant of brillantService.data.brillants">
                        <td>
                            <p>
                                <a [href]="'/api/brillants/' + brillant[BrillantField.groesse]">
                                    {{steingroesseForDisplay(brillant[BrillantField.groesse])}}
                                </a>
                            </p>
                        </td>

                        <td>
                            <p>
                                {{brillant[BrillantField.twsi] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.wsi] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.twif] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.princess] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.siSchwarz] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.siBlau] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.siGruen] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.siBraun] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.siGelb] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.rubin] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.saphir] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.smaragd] | euro}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{brillant[BrillantField.zirkonia] | euro}}
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
    </div>
</div>
